module.exports = __webpack_public_path__ + "img/制御工学8_5.5d8a6c57.png";